import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.profile-attributes.edit', {
        url: '/edit',
        views: {
            '@company.user-directories.manage-account': 'companyUserDirectoriesManageAccountProfileAttributesEdit',
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.state.js